import axios from "axios";
import { format, parseISO } from "date-fns";
import { es, enUS } from "date-fns/locale";
import type { BlockKey, Prices } from "@/types";

export const BACKEND = process.env.REACT_APP_BACKEND_URL as string;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing: Promise<unknown> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url: string = cfg?.url || "";
    if (error.response?.status === 401 && cfg && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export function errDetail(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return "generic";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d?.msg || d);
}

export const imgSrc = (u?: string) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "/images/hero.jpg");

export const BLOCKS: BlockKey[] = ["4h", "6h", "8h", "overnight"];
export const PRICE_KEY: Record<BlockKey, keyof Prices> = { "4h": "h4", "6h": "h6", "8h": "h8", overnight: "overnight" };

export const fmtUSD = (n: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export const toISO = (d: Date) => format(d, "yyyy-MM-dd");
export const fmtDate = (iso: string, lang: string) =>
  format(parseISO(iso), lang === "es" ? "d 'de' MMMM yyyy" : "MMMM d, yyyy", { locale: lang === "es" ? es : enUS });

export const WHATSAPP_URL = "https://wa.me/529986835267";
export const WHATSAPP_DISPLAY = "+52 998 683 5267";
export const CONTACT_EMAIL = "reservaciones@legendaryvacationclubrenting.com";
export const AMENITIES = ["captain", "crew", "snorkel", "ice", "water", "sound", "wc", "aircon", "flybridge", "jacuzzi", "chef", "paddle", "towels", "fuel"];
export const YACHT_TYPES = ["sport", "motor", "catamaran", "flybridge", "superyacht"];
